import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Popover } from 'antd';
import { fetchAuthorizedAPIEndpoint } from '../../utils';

type UserInfoWidgetProps = {};

const UserInfoWidget: React.FC<UserInfoWidgetProps> = () => {
  const { user, getAccessTokenSilently, logout } = useAuth0();
  const [accessToken, setAccessToken] = useState<string | undefined>();

  const [licenseEndTs, setLicenseEndTs] = useState<number | null | undefined>(undefined);

  let logoutURI = window.location.origin + '/signout/callback';
  if (user?.idp_logout_uri) {
    logoutURI = user.idp_logout_uri;
  }

  useEffect(() => {
    if (!accessToken) return;

    fetchAuthorizedAPIEndpoint('/user/get_trial_period', accessToken)
      .then((resp) => {
        if (resp.ok) {
          return resp.json();
        } else {
          throw resp.json();
        }
      })
      .then((data: { LicenseEndTs: number }) => {
        setLicenseEndTs(data.LicenseEndTs);
      });
  }, [accessToken]);

  if (!user || user === null) return null;

  return (
    <Popover
      trigger="click"
      placement="bottomRight"
      styles={{ body: { borderRadius: 5 } }}
      title={
        <div style={{ textAlign: 'center' }}>
          <span style={{ fontWeight: 'bold' }}>{user.name}</span>
          <br />
          <span>
            <i>{user.email}</i>
          </span>
        </div>
      }
      content={
        <>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button type="primary" block onClick={() => logout({ logoutParams: { returnTo: logoutURI, federated: true } })}>
              Logout
            </Button>
          </div>
          <div style={{ textAlign: 'center', marginTop: 10 }}>
            {licenseEndTs ? (
              <>
                License valid through <b>{new Date(licenseEndTs).toDateString()}</b>
              </>
            ) : null}
          </div>
          <div style={{ textAlign: 'center', marginTop: 10 }}>
            <p style={{ fontSize: 12, marginBottom: 0 }}>
              Digital Olfaction Hub <b>{process.env.REACT_APP_VERSION}</b>
            </p>
            <p style={{ fontSize: 12, marginBottom: 0 }}>© 2022 Aryballe</p>
          </div>
        </>
      }
    >
      <FontAwesomeIcon icon="user-cog" style={{ width: 20, height: 20, cursor: 'pointer' }} />
    </Popover>
  );
};

export default UserInfoWidget;
